import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, Input, MultiSelect } from '@Components/Filters';

import { FilterForm } from './types';
import {
  purposeLabels,
  statusLabels,
} from '../store/selectors/passportRequestSelector';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const purposeTypes = useAppSelector(purposeLabels);
  const statuses = useAppSelector(statusLabels);

  const items: CollapseProps['items'] = [
    {
      id: 'PURPOSE',
      label: 'Purpose',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="purposes"
          options={purposeTypes}
        />
      ),
    },
    {
      id: 'DATE RANGE',
      label: 'Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="dateFrom"
          toKey="dateTo"
        />
      ),
    },
    {
      id: 'TOTAL NO OF DAYS',
      label: 'Total no. of days',
      children: <Input<FilterForm> formik={formik} formikKey="totDays" />,
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
